import React from 'react';

import { Paragraph } from '../components/Paragraph';
import { Subtitle } from '../components/Subtitle';

export const AccessToOrRequestForCorrectionOfData = () => {
  return (
    <>
      <Subtitle>Access to or Request for Correction of Data</Subtitle>
      <Paragraph>
        You are entitled to request access to or make amendments to your own
        personal information and data kept with Glints by contacting Glints
        using the contact details set out under the section headed “Enquiries“.
        Subject to the paragraph below, you may alternatively edit, amend or
        delete your personal information and data at any time by logging into
        the “My Profile” section of the Site.
      </Paragraph>
      <Paragraph>
        In the event that you wish to access or amend your personal information
        and data, Glints may request you to provide personal details in order to
        verify your identity.
      </Paragraph>
      <Paragraph>
        Glints will respond to your request as soon as reasonably possible.
        Should Glints not be able to respond to your request within thirty (30)
        days after receiving your request, Glints will inform you in writing
        within thirty (30) days of the time by which Glints will be able to
        respond to your request. Where legally permitted, if Glints is unable to
        provide you with any personal data or to make a correction requested by
        you, we shall generally inform you of the reasons why we are unable to
        do so.
      </Paragraph>
    </>
  );
};
